
interface IssueSectionProps {
  issue: string;
}

const IssueSection = ({ issue }: IssueSectionProps) => {
  return (
    <div className="mt-3 pt-3 border-t text-sm">
      <p className="text-muted-foreground mb-1">Issue:</p>
      <p>{issue}</p>
    </div>
  );
};

export default IssueSection;
